import { useCallback } from 'react';
import { rotateNext } from '../utils';

const RIGHT_ROTATION = {
  'rotate-0': 'rotate-90',
  'rotate-90': 'rotate-180',
  'rotate-180': 'rotate-270',
  'rotate-270': 'rotate-0',
};

export const useRotateRight = (upload) =>
  useCallback(
    (e) => {
      e.stopPropagation();
      rotateNext(upload, RIGHT_ROTATION);
    },
    [upload],
  );
